class CollectionFilterDrawer {
  constructor(sectionId) {
    this.sidebar = document.getElementById(`CollectionFilters-${sectionId}`);
    if (!this.sidebar) return;

    this.section = this.sidebar.closest('.collection-shop');
    this.backdrop = this.section ? this.section.querySelector('[data-filter-backdrop]') : null;
    this.openBtn = this.section ? this.section.querySelector('[data-filter-open]') : null;
    this.closeBtn = this.sidebar.querySelector('[data-filter-close]');

    if (this.openBtn) {
      this.openBtn.addEventListener('click', () => this.open());
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.sidebar.classList.add('is-open');
    if (this.backdrop) this.backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.sidebar.classList.remove('is-open');
    if (this.backdrop) this.backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
}

window.CollectionFilterDrawer = CollectionFilterDrawer;
